import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import { Focusable, FocusableParent } from './navigation';
import BackIcon from './Icons/back';

const StyledBackButton = styled(Focusable)`
  font-size: ${scaleSize(72)}px;
  line-height: ${scaleSize(88)}px;
  font-family: 'RobotoBold', sans-serif;
  position: absolute;
  top: ${scaleSize(46)}px;
  left: ${scaleSize(34)}px;
  text-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.25);

  &:focus {
    svg > path {
      stroke: ${({ theme }) => theme.activeColor};
    }
  }
`;

class BackButton extends Component {
  render() {
    const {
      onEnter,
      onFocus,
      className,
      navigationConfig,
      sectionName,
      defaultSection,
    } = this.props;

    return (
      <FocusableParent
        sectionName={sectionName || 'BACK_BUTTON'}
        config={{ preventMouseNavigateIn: true, ...navigationConfig }}
        defaultSection={defaultSection}
      >
        <StyledBackButton
          onEnter={onEnter}
          onFocus={onFocus}
          className={className}
          focusOnMouseEnter
        >
          <BackIcon />
        </StyledBackButton>
      </FocusableParent>
    );
  }
}

export default BackButton;
